<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useDateLocale } from 'dashboard/composables/useTimeAgo';
import BaseBubble from './Base.vue';
import { useMessageContext } from '../provider.js';

const { t } = useI18n();
const { localeTag } = useDateLocale();
const { contentAttributes, content } = useMessageContext();

const catalogProduct = computed(
  () => contentAttributes.value?.catalogProduct || {}
);

const productTitle = computed(() => catalogProduct.value.productTitle);
const variantTitle = computed(() => catalogProduct.value.variantTitle);
const price = computed(() => {
  const p = catalogProduct.value.price;
  if (!p) return '';
  return new Intl.NumberFormat(localeTag.value, {
    style: 'currency',
    currency: 'BRL',
  }).format(parseFloat(p));
});
const thumbUrl = computed(() => catalogProduct.value.thumbUrl);
const hasContent = computed(() => !!content.value);

const spmTemplate = computed(
  () => contentAttributes.value?.whatsappSpmTemplate || {}
);
const buttonText = computed(
  () => spmTemplate.value?.urlButtonText || t('CATALOG.PRODUCT_BUBBLE.VIEW')
);
</script>

<template>
  <BaseBubble
    class="overflow-hidden p-0 !bg-n-slate-3 !text-n-slate-12"
    data-bubble-name="catalog-product"
  >
    <div class="w-72">
      <!-- Inner card -->
      <div class="mx-2 mt-2 mb-1 rounded-lg bg-n-slate-4 overflow-hidden">
        <div v-if="thumbUrl" class="w-full h-36 overflow-hidden">
          <img
            :src="thumbUrl"
            :alt="productTitle"
            class="w-full h-full object-cover"
          />
        </div>
        <div class="px-2 py-1.5 space-y-0.5">
          <p
            v-if="productTitle"
            class="text-xs font-bold text-n-slate-12 leading-snug"
          >
            {{ productTitle }}
          </p>
          <p v-if="variantTitle" class="text-xs text-n-slate-9">
            {{ variantTitle }}
          </p>
          <p v-if="price" class="text-xs font-semibold text-n-slate-12">
            {{ price }}
          </p>
        </div>
      </div>

      <!-- Body text -->
      <div v-if="hasContent" class="px-2 py-1.5">
        <p class="text-xs text-n-slate-10">{{ content }}</p>
      </div>

      <!-- Footer: Ver -->
      <div class="border-t border-n-slate-6">
        <a
          href="#"
          class="flex items-center justify-center px-2 py-2 text-xs font-medium text-n-slate-11 hover:text-n-slate-12 hover:bg-n-slate-4 transition-colors"
        >
          {{ buttonText }}
        </a>
      </div>
    </div>
  </BaseBubble>
</template>
